import {
  TextColorPicker,
  TextBold,
  TextItalic,
  TextUnderline,
  TextListBullets,
  TextListNumbered,
  TextAlignCenter,
  TextAlignJustify,
  TextAlignLeft,
  TextAlignRight,
  TextLink,
  AddImage,
} from '@/assets/icons';

export const TOOLBAR_CONFIG = {
  options: ['fontFamily', 'inline', 'fontSize', 'colorPicker', 'list', 'textAlign', 'link', 'image'],
  inline: {
    inDropdown: false,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline'],
    bold: { icon: TextBold },
    italic: { icon: TextItalic },
    underline: { icon: TextUnderline },
  },
  list: {
    inDropdown: false,
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered'],
    unordered: { icon: TextListBullets },
    ordered: { icon: TextListNumbered },
  },
  colorPicker: {
    icon: TextColorPicker,
  },
  textAlign: {
    left: { icon: TextAlignLeft },
    center: { icon: TextAlignCenter },
    right: { icon: TextAlignRight },
    justify: { icon: TextAlignJustify },
  },
  link: {
    options: ['link'],
    link: { icon: TextLink },
  },
  image: {
    icon: AddImage,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: true,
    uploadCallback: async (file: File): Promise<{ data: { link: string } }> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          const src = reader.result;
          if (typeof src !== 'string') return reject(src);

          return resolve({
            data: { link: src },
          });
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      }),
    previewImage: true,
    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    alt: { present: false, mandatory: false },
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
} as const;
